module.exports = __webpack_public_path__ + "img/contentImg1.0cda1fc.png";